import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import {
  EntityDepartamentosState,
  entityDepartamentosAdapter
} from './entity-departamentos.state';

const { selectEntities, selectAll } = entityDepartamentosAdapter.getSelectors();

export const getError = (state: EntityDepartamentosState): any => state.error;

export const getIsLoading = (state: EntityDepartamentosState): boolean =>
  state.isLoading;

export const selectDepartamentosState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.departamentos
);

export const selectAllDepartamentos = createSelector(
  selectDepartamentosState,
  selectAll
);
export const selectEntitiesDepartamentos = createSelector(
  selectDepartamentosState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectDepartamentosError = createSelector(
  selectDepartamentosState,
  getError
);

// MemoizedSelector<object,any>
export const selectDepartamentosIsLoading = createSelector(
  selectDepartamentosState,
  getIsLoading
);
